import React, { FC } from 'react';
import styled from 'styled-components';
import { Typography } from '@material-ui/core';
import {
  bindPopover,
  PopupState,
} from 'material-ui-popup-state/hooks';
import Popover from 'material-ui-popup-state/HoverPopover';

const PopoverName = styled(Typography)`
  color: white;
  margin: 0.5rem;
  font-weight: 600;
  word-break: break-word;
`;

const PopoverBody = styled(Typography)`
  color: white;
  margin: 0.5rem;
  word-break: break-word;
`;

const popoverPaperProps = {
  style: {
    backgroundColor: 'rgba(25, 25, 25, 0.8)',
    maxWidth: '250px',
    padding: '0.5rem',
  },
};

export interface SpeakerItemPopoverProps {
  popupState: PopupState;
  name: string;
  company: string;
  title: string;
}

const SpeakerItemPopover: FC<SpeakerItemPopoverProps> = ({
  popupState,
  name = '',
  company = '',
  title = '',
}: SpeakerItemPopoverProps) => (
  <Popover
    {...bindPopover(popupState)}
    anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'center',
    }}
    transformOrigin={{
      vertical: 'top',
      horizontal: 'center',
    }}
    disableRestoreFocus
    PaperProps={popoverPaperProps}
  >
    <PopoverName>
      {name}
    </PopoverName>
    <PopoverBody>
      {company}
    </PopoverBody>
    <PopoverBody>
      {title}
    </PopoverBody>
  </Popover>
);

export default SpeakerItemPopover;
